"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILE_READER_FUNCTION_TEXT = exports.FILE_READER_FUNCTION_BINARY = exports.FILE_READER_FUNCTION_BASE_64 = exports.FILE_READER_FUNCTION_ARRAY_BUFFER = exports.PARSE_TYPE_ARRAY_BUFFER = exports.PARSE_TYPE_BINARY = exports.PARSE_TYPE_TEXT = exports.PARSE_TYPE_BASE_64 = void 0;

/* eslint one-var: off */
var PARSE_TYPE_BASE_64 = 'base64';
exports.PARSE_TYPE_BASE_64 = PARSE_TYPE_BASE_64;
var PARSE_TYPE_TEXT = 'text';
exports.PARSE_TYPE_TEXT = PARSE_TYPE_TEXT;
var PARSE_TYPE_BINARY = 'binary';
exports.PARSE_TYPE_BINARY = PARSE_TYPE_BINARY;
var PARSE_TYPE_ARRAY_BUFFER = 'arrayBuffer';
exports.PARSE_TYPE_ARRAY_BUFFER = PARSE_TYPE_ARRAY_BUFFER;
var FILE_READER_FUNCTION_ARRAY_BUFFER = 'readAsArrayBuffer';
exports.FILE_READER_FUNCTION_ARRAY_BUFFER = FILE_READER_FUNCTION_ARRAY_BUFFER;
var FILE_READER_FUNCTION_BASE_64 = 'readAsDataURL';
exports.FILE_READER_FUNCTION_BASE_64 = FILE_READER_FUNCTION_BASE_64;
var FILE_READER_FUNCTION_BINARY = 'readAsBinaryString';
exports.FILE_READER_FUNCTION_BINARY = FILE_READER_FUNCTION_BINARY;
var FILE_READER_FUNCTION_TEXT = 'readAsText';
exports.FILE_READER_FUNCTION_TEXT = FILE_READER_FUNCTION_TEXT;